import React, { useCallback } from 'react'

import clsx from 'clsx'
import { Button as MuiButton, Typography } from '@mui/material'
import { isCsvOnlyDownloadLabel } from 'src/domain/org'
import { isCsvExportable } from 'src/domain/reportStatus'
import {
  AdminAdminSalesReportManagerRoles,
  isOneOfRoles,
} from 'src/domain/role'
import { RoleEnum, TenantSalesReportSummary } from 'src/slices/services/api'
import style from './styles.module.scss'

export type DownloadCSVButtonProps = {
  role?: RoleEnum
  summaries: TenantSalesReportSummary[]
  orgCode: string
  onClick?: () => void
} & React.StyledProps

const DownloadCSVButton: React.StyledFC<DownloadCSVButtonProps> = ({
  role,
  summaries,
  orgCode,
  onClick,
}: DownloadCSVButtonProps) => {
  const isDownloadCSVAvailableByRole = useCallback((): boolean => {
    return isOneOfRoles(AdminAdminSalesReportManagerRoles, role)
  }, [role])
  // 出力対象のステータスはorgごとに異なる（既定=確定済みのみ / パルコ=報告済み・再送済みのみ）
  const isDeny = !summaries.some((summary) =>
    isCsvExportable(orgCode, summary.reportStatus)
  )
  const isDisabled = !isDownloadCSVAvailableByRole() || isDeny

  // CSVのみダウンロード対象組織はCSVのみ、それ以外はCSV・Excel
  const buttonLabel = isCsvOnlyDownloadLabel(orgCode) ? (
    <>
      CSV
      <br />
      ダウンロード
    </>
  ) : (
    <>
      CSV・Excel
      <br />
      ダウンロード
    </>
  )

  return (
    <MuiButton
      className={clsx(
        style.button,
        isDisabled ? style.deactivate : style.active
      )}
      onClick={onClick}
      disabled={isDisabled}
    >
      <Typography className={style.title}>{buttonLabel}</Typography>
    </MuiButton>
  )
}

export default DownloadCSVButton
